import styled from 'styled-components';
import { fonts, spacing } from 'ui/theme';

export const TableWrapper = styled.div`
  display: grid;
  grid-template-columns: [col-campaign] auto [col-percent] min-content;
  align-items: stretch;
  font-family: ${fonts.sansSerif};
  background-color: #fff;
  margin: 0 -${spacing.base} 0 -${spacing.plusHalf};
`;
